import { notification } from 'antd';
import React from 'react';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
// Style
// import './resources/style/main.css';
import './resources/style/main.scss';
import './resources/style/mainCustomTheme.less';
import { store } from './store';

notification.config({
	duration: 3,
});

const container = document.getElementById('root');

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	container
);
